import React, {useState, useCallback} from 'react';
import { Breadcrumb, Col, Form, Row } from 'react-bootstrap';
import DatePick from '../../Components/DatePicker/DatePicker';
import Card from '../../UI/Card/Card';
import SecBTN from '../../UI/SecBTN';
import Graybg from "../../UI/Graybg";
import userService from '../../app/services/user.service';
import Loader from '../../UI/loader/loader';
import {isEmpty} from '../../utils/custom_funtions';
import ReportCard from './ReportCard';
import { toast } from 'react-toastify';

const CourseReport = () => {
    const user_id = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;
    const [loading, setLoading] = useState(false)
    const [dates, setDates] = useState({
      start:'',
      end:'',
    })
    const [reportList, setReportList] = useState([])
    
    // const [selectedDate, setSelectedDate] = useState(new Date().toLocaleString("sv-SE").slice(0,10))
    const getReports = useCallback(() => {
      setLoading(true)
      const body = {
        faculty_id: user_id,
        from_date: dates.start.toLocaleString("sv-SE").slice(0,10),
        to_date: dates.end.toLocaleString("sv-SE").slice(0,10),
      };
      console.log(body)
      userService.getReports(body)
      .then(res => {
        console.log(res.data)
        if(res.data == "Not Found"){
          setReportList([])
          toast.error("Data Not found")
        } else {
          setReportList(res.data)
        }
        
        setLoading(false)
      })
      .catch(err => {
        console.log(err)
        toast.error("Something went wrong!");
        setLoading(false);
      })
    },[dates])
    

  return (
    <>
      {loading && <Loader />}
      <div className="section">
        <h4>Course Report</h4>
        <Breadcrumb>
          <Breadcrumb.Item active>Course Report</Breadcrumb.Item>
        </Breadcrumb>
        <Card>
          <Row>
            <Col lg={4}>
              <Form.Label htmlFor="Batch">Start Date :</Form.Label>
              <DatePick
                required={true}
                placeholder="Select Start Date"
                selected={dates.start}
                maxDate={dates.end}
                onChange={(date) =>
                  setDates((prev) => {
                    return { ...prev, start: date };
                  })
                }
              />
            </Col>
            <Col lg={4}>
              <Form.Label htmlFor="Batch">End Date :</Form.Label>
              <DatePick
                required={true}
                placeholder="Select End Date"
                minDate={dates.start}
                selected={dates.end}
                onChange={(date) =>
                  setDates((prev) => {
                    return { ...prev, end: date };
                  })
                }
              />
            </Col>
            <Col lg={4} style={{ alignSelf: "end" }}>
              <SecBTN
                className="sec-btn1"
                onClick={getReports}
                disabled={dates.start == "" || dates.end == "" ? true : false}
              >
                Get Report
              </SecBTN>
            </Col>
          </Row>
        </Card>
        {!isEmpty(reportList) && (
          <Graybg>
            {reportList.map((data) => {
              return <ReportCard data={data} />;
            })}
          </Graybg>
        )}
      </div>
    </>
  );
}

export default CourseReport
